import { 
  FaCar,           // Automotive & Auto Ancillary / Auto Components
  FaCogs,          // Steel & Foundry / Metal Fabrication / General Industry
  FaSpaceShuttle,  // Aerospace
  FaTv,            // Electronics & Home Appliances
  FaBuilding,      // Building & Constructions / Builders / Architects
  FaMicrochip,     // Optional: PCS / Electronics
  FaShieldAlt,     // Optional: Defense
  FaChair,         // Furniture & Decorative / Interior Designers / Furniture
  FaPaintRoller,   // Painting / Coatings
  FaBoxOpen,       // Consumer Goods
  FaGem,           // Imitation Jewelry
  FaStar,          // Specialties
  FaHandsHelping,  // Handicraft
  FaCouch,         // Home Furnishing
  FaUtensils,      // Cookware
  FaBolt           // Energy & Infrastructure
} from "react-icons/fa";

// ========================
// CATEGORY: PLATING & SPECIALITY CHEMICALS
// ========================
import PLATINGANDSPECIALITYCHEMICALSBannerImg from "../src/assets/speciality-banner.png";
import BasicLabChemicalsBannerImg from "../src/assets/Basic-lab-chemicals-banner.png";
import METALSBannerImg from "../src/assets/metals-imports-banner.png";
import abrasivesBannerImg from "../src/assets/abrasives-banner.png";
import CUTTINGTOOLSBannerImg from "../src/assets/cutting-tools-banner.png";
import WOODGLASSCOATINGSBannerImg from "../src/assets/wood-glass-coatings-Banner.png";
import metalCoatingsBannerImg from "../src/assets/ferro-alloys-banner.png";

import electrolessNickelImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/ELECTROLESS-NICKEL.png";
import zincFlakeImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/ZINC-FLAKE-COATINGS.png";
import tinImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/TIN-PLATING.png";
import zincAlloyImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/ZINC-ALLOY-PLATING.png";
import nickelImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/NICKEL-PLATING.png";
import copperproductsImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/COPPER PLATING.png";
import platingPlasticImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/PLATING-ON-PLASTIC.png";
import hardChromeImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/HARD-CHROME-PLATING.png";
import paintSupportImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/paint-support-technology.png";
import corrosionResistanceImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/CORROSION-RESISTANCE-COATINGS.png";
import functionalElectroImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/FUNCTIONAL-ELECTRO-COATINGS.png";
import degreasingImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/DEGREASING-CHEMICALS.png";

// Substrates
import brassImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/Brass.png";
import stainlessImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/stainless.png";
import absImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/abs.png";
import copperImg5 from "../src/assets/SubProducts/Metals/Copper.png";
import aluminumImg from "../src/assets/SubProducts/Plating-Specialty-Chemicals/aluminum.png";

// ========================
// CATEGORY: BASIC & LAB CHEMICALS
// ========================

import chromicAcidImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/CHROMIC ACID FLAKES & LIQUID.png";
import nickelSulphateImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/NICKEL SULPHATE.png";
import nickelSuphamateImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/NICKEL SUPHAMATE.png";
import nickelChlorideImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/NICKEL CHLORIDE.png";
import boricAcidImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/NICKEL CHLORIDE (1).png";
import causticSodaImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/CAUSTIC SODA.png";
import nickelCarbonateImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/NICKEL CARBONATE.png";
import labChemicalsImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/OTHER BASIC LAB CHEMICALS.png";


import msImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/MS.png";
import brassLabImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/Brass.png";
import stainlessLabImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/Stainless-Steel.png";
import absLabImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/abs.png";
import copperLabImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/Copper.png";
import aluminumLabImg from "../src/assets/SubProducts/Basic-Lab-Chemicals/Aluminum.png";

import TitaniumImg from "../src/assets/SubProducts/cutting-tools/TitaniumImg.png";
import InconelImg from "../src/assets/SubProducts/cutting-tools/InconelImg.png";
import CastIronImg from "../src/assets/SubProducts/cutting-tools/CastIronImg.png";
import NickelImg from "../src/assets/metals-imports/Nickel.png";
import SECOImg from "../src/assets/SubProducts/cutting-tools/SECo.png";

import bondedpdf from "../src/assets/SubProducts/BONDED-ABRASIVES.pdf";
import coatedpdf from "../src/assets/SubProducts/COATED-ABRASIVES.pdf";
import nonwovenpdf from "../src/assets/SubProducts/NON-WOVEN-ABRASIVES.pdf";
import superabrasivepdf from "../src/assets/SubProducts/SUPERABRASIVES.pdf";
import thinwheelspdf from "../src/assets/SubProducts/THIN-WHEELS.pdf";
import constructionpdf from "../src/assets/SubProducts/CONSTRUCTION-PRODUCTS.pdf";

import TitaniumImg1 from "../src/assets/SubProducts/Metals/MS.png";
import brassImg1 from "../src/assets/SubProducts/Metals/Brass.png";
import stainlessImg1 from "../src/assets/SubProducts/Metals/Stainless.png";
import absImg1 from "../src/assets/SubProducts/Basic-Lab-Chemicals/abs.png";
import copperImg1 from "../src/assets/SubProducts/Metals/Copper.png";
import aluminumImg1 from "../src/assets/SubProducts/Metals/Aluminum.png";

// ========================
// Product Images (Unique IDs/Names)
// ========================
import nickelImg1 from "../src/assets/SubProducts/Metals/NICKEL.png"; // id 1
import zincImg1 from "../src/assets/SubProducts/Metals/ZINC.png";     // id 2
import oxygenCopperImg1 from "../src/assets/SubProducts/Metals/OXYGEN-FREE-COPPER.png"; // id 3
import phosphorCopperImg1 from "../src/assets/SubProducts/Metals/PHOSPHORISED-PURE-COPPER.png"; // id 4
import tinImg1 from "../src/assets/SubProducts/Metals/TIN.png";       // id 5
import leadImg1 from "../src/assets/SubProducts/Metals/LEAD.png";


// ✅ Abrasives Images
import bondedImg from "../src/assets/SubProducts/Abrasives/Bonded.png";
import coatedImg from "../src/assets/SubProducts/Abrasives/Coated.png";
import nonwovenImg from "../src/assets/SubProducts/Abrasives/Nonwoven.png";
import superabrasiveImg from "../src/assets/SubProducts/Abrasives/Superabrasive.png";
import thinwheelsImg from "../src/assets/SubProducts/Abrasives/Thinwheels.png";
import constructionImg from "../src/assets/SubProducts/Abrasives/construction.png";
import PlywoodImg from "../src/assets/SubProducts/Abrasives/Plywood.png";

import millingImg1 from "../src/assets/SubProducts/cutting-tools/Milling Cutters & Solid End Mills.png";
import turningInsertsImg1 from "../src/assets/SubProducts/cutting-tools/ISO Turning Inserts, Grooving & CBN inserts.png";
import carbideDrillsImg1 from "../src/assets/SubProducts/cutting-tools/NON-WOVEN ABRASIVES.png";
import turningMillingTappingImg1 from "../src/assets/SubProducts/cutting-tools/Turning, Milling & Tapping.png";
import toolingSystemsImg1 from "../src/assets/SubProducts/cutting-tools/Rotating Holders, Stationary Adapters & Shrink fit Devices.png";

// Substrate images
import mdfImg from "../src/assets/SubProducts/Wood-Glass-Coatings/MDF.png";
import woodImg from "../src/assets/SubProducts/Wood-Glass-Coatings/Wood.png";
import glassImg from "../src/assets/SubProducts/Wood-Glass-Coatings/Glass.png";
import hdfImg from "../src/assets/SubProducts/Wood-Glass-Coatings/HDF.png";
import tilesImg from "../src/assets/SubProducts/Wood-Glass-Coatings/Tiles.png";

// Product images
import alkydPolyurethaneImg from "../src/assets/SubProducts/Wood-Glass-Coatings/ALKYD-POLYURETHANE-COATINGS.png";
import acrylicPolyurethaneImg from "../src/assets/SubProducts/Wood-Glass-Coatings/ACRYLIC-POLYURETHANE-COATINGS.png";
import uvCoatingsImg from "../src/assets/SubProducts/Wood-Glass-Coatings/UV-COATINGS.png";
import waterBorneImg from "../src/assets/SubProducts/Wood-Glass-Coatings/WATER-BORNE-EXTERIOR-INTERIOR.png";
import puGlassImg from "../src/assets/SubProducts/Wood-Glass-Coatings/PU-GLASS-COATINGS.png";
import epoxyAcrylicImg from "../src/assets/SubProducts/Wood-Glass-Coatings/EPOXY-ACRYLIC-ISOLATORS.png";
import melamineImg from "../src/assets/SubProducts/Wood-Glass-Coatings/MELAMINE.png";
import specialEffectsImg from "../src/assets/SubProducts/Wood-Glass-Coatings/SPECIAL-EFFECTS.png";
import glazersDyesImg from "../src/assets/SubProducts/Wood-Glass-Coatings/GLAZERS-DYES.png";
import stainsImg from "../src/assets/SubProducts/Wood-Glass-Coatings/SOLVENT-WATER-UNIVERSAL-STAINS.png";
import fireRetardantImg from "../src/assets/SubProducts/Wood-Glass-Coatings/FIRE-RETARDANT-COATINGS.png";
import pigmentedImg from "../src/assets/SubProducts/Wood-Glass-Coatings/PIGMENTED-COATINGS.png";

import mildSteelImg3 from "../src/assets/SubProducts/metal-coatings/Mild Steel.png";
import brassImg3 from "../src/assets/SubProducts/metal-coatings/Brass.png";
import stainlessSteelImg3 from "../src/assets/SubProducts/metal-coatings/Stainless-Steel.png";
import absImg3 from "../src/assets/SubProducts/Basic-Lab-Chemicals/abs.png";
import aluminumImg3 from "../src/assets/SubProducts/metal-coatings/Aluminum.png";
import frpImg3 from "../src/assets/SubProducts/metal-coatings/FRP.png";
import plasticSteelImg3 from "../src/assets/SubProducts/metal-coatings/Plastic-Steel.png";

// Product Images
import epoxyImg from "../src/assets/SubProducts/metal-coatings/EPOXY-COATINGS.png";
import polyurethaneImg from "../src/assets/SubProducts/metal-coatings/ACRYLIC-POLYURETHANE-COATINGS.png";
import antibacterialImg from "../src/assets/SubProducts/metal-coatings/antibacterial.png";
import softFeelImg from "../src/assets/SubProducts/metal-coatings/SOFT-FEEL-LACQUER-METAL-COATINGS.png";
import monoCoatImg from "../src/assets/SubProducts/metal-coatings/MONO-COAT-DTM.png";
import electrophoreticImg from "../src/assets/SubProducts/metal-coatings/ELECTROPHORETIC.png";
import tpaImg from "../src/assets/SubProducts/metal-coatings/ELECTROPHORETIC (1).png";
import tsaImg from "../src/assets/SubProducts/metal-coatings/THERMOSETTING-ACRYLIC-TSA.png";
import uvCurableImg from "../src/assets/SubProducts/metal-coatings/UV-CURABLE-METAL-COATINGS.png";


export const productCategories = [
  {
    id: 1,
    slug: "plating-and-speciality-chemicals",
    name: "PLATING AND SPECIALITY CHEMICALS",
  bannerTitle: "PLATING AND SPECIALITY CHEMICALS",
  bannerImage: PLATINGANDSPECIALITYCHEMICALSBannerImg, 
    industries: [
      { id: 1, name: "Automotive", icon: FaCar },
      { id: 2, name: "Aerospace", icon: FaSpaceShuttle },
      { id: 3, name: "PCB", icon: FaMicrochip },
      { id: 4, name: "Electronics", icon: FaTv },
      { id: 5, name: "General Plating Industries", icon: FaCogs },
    ],
    substrates: [
      { id: 1, name: "Brass", img: brassImg },
      { id: 2, name: "Stainless Steel", img: stainlessImg },
      { id: 3, name: "ABS", img: absImg },
      { id: 4, name: "Copper", img: copperImg5 },
      { id: 5, name: "Aluminum", img: aluminumImg },
      { id: 6, name: "Mild Steel", img: msImg },
    ],
    products: [
  {
    id: 1,
    name: "ELECTROLESS NICKEL",
    img: electrolessNickelImg,
    description:
      "Electroless nickel plating (ENP) is a chemical deposition process that applies a uniform,corrosion-resistant nickel-phosphorus (or boron) alloy coating to a substrate without using electricity. Key benefits include its autocatalytic chemical reaction that ensures uniform thickness on complex shapes, excellent wear and corrosion resistance, and the ability to achieve high hardness after heat treatment.",
  },
  {
    id: 2,
    name: "ZINC FLAKE COATINGS",
    img: zincFlakeImg,
    description:
      "Zinc flake coating is a high-performance, non-electrolytic coating system that provides excellent corrosion resistance for metal components, especially in automotive and industrial applications. It consists of a base coat of zinc and aluminium flakes suspended in a binder, which is then cured on the metal surface. This sacrificial coating method offers superior protection, good adhesion, and can provide specific friction coefficients and aesthetic finishes, making it a durable and environmentally friendly alternative to some traditional coatings.",
  },
  {
    id: 3,
    name: "TIN PLATING",
    img: tinImg,
    description:
      "Tin plating is the process of coating a metal object with a thin layer of tin or a tin alloy to provide corrosion resistance, improve solderability, and enhance electrical conductivity. The process is widely used in electronics, food packaging, and other industries, and can be done using methods like electroplating (galvanic), hot dipping, or chemical displacement.",
  },
  {
    id: 4,
    name: "ZINC ALLOY PLATING",
    img: zincAlloyImg,
    description:
      "Zinc alloy plating involves electroplating a mixture of zinc and another metal, such as nickel or tin, onto a substrate to enhance corrosion resistance, wear resistance, and durability beyond that of pure zinc. This process uses acid or alkaline baths to co-deposit the metals, with common alloys including zinc-nickel (around 85% zinc, 15% nickel) and tin-zinc, which offer superior protection in harsh environments and meet specifications for various industries, particularly automotive",
  },
  {
    id: 5,
    name: "NICKEL PLATING",
    img: nickelImg,
    description:
      "Nickel plating is a surface treatment that applies a layer of nickel onto a substrate to improve its corrosion resistance, wear resistance, hardness, and aesthetic appeal. The two main methods are electroless nickel plating, which uses chemical reactions without an electric current, and nickel electroplating, which uses an electric current to deposit the nickel layer",
  },
  {
    id: 6,
    name: "COPPER PLATING",
    img: copperproductsImg,
    description:
      "Copper plating is a process that applies a layer of copper to a surface, typically for corrosion protection, improved wear resistance, enhanced conductivity, or decorative purposes. The most common method is electroplating, where an electric current causes copper ions to transfer from an anode to the object being plated (the cathode) in an electrolyte solution. Another method is electroless plating, which uses a chemical process without electricity to deposit an even copper layer, even on non-conductive surfaces.",
  },
  {
    id: 7,
    name: "PLATING ON PLASTIC",
    img: platingPlasticImg,
    description:
      "Plating on plastic is a process of applying a metallic coating to a plastic part, typically using electroplating, to enhance its appearance, conductivity, hardness, and resistance to corrosion and wear. The process involves special surface preparation, including etching the plastic to improve adhesion, and is commonly applied to ABS plastic for automotive, electronic, and decorative parts. ",
  },
  {
    id: 8,
    name: "HARD CHROME PLATING",
    img: hardChromeImg,
    description:
      "Hard chrome plating is an electroplating process that deposits a thick, durable layer of chromium onto a metal surface to enhance its hardness, wear resistance, corrosion resistance, and reduce friction. It improves the performance of components such as piston rods, rollers, and hydraulic cylinder rods.",
  },
  {
    id: 9,
    name: "PAINT SUPPORT TECHNOLOGY",
    img: paintSupportImg,
    description:
      "We offer full range of products for pretreatment, paint removal and paint overspray treatment applications. These are technologies that offer a sustainable alternative to conventional processes, free of hazardous/regulated substances while supporting CO2 reduction. We provide applicators with economical process with longer solution life, reducing waste generation and product consumption. ",
  },
  {
    id: 10,
    name: "CORROSION RESISTANCE COATINGS",
    img: corrosionResistanceImg,
    description:
      "Corrosion Resistance Coatings extend the lifespan of components by protecting against harsh environments and chemical exposure.",
  },
  {
    id: 11,
    name: "FUNCTIONAL ELECTRO COATINGS",
    img: functionalElectroImg,
    description:
      "Functional Electro Coatings provide specialized properties like wear resistance, conductivity, or insulation, tailored for advanced engineering needs.",
  },
  {
    id: 12,
    name: "DEGREASING CHEMICALS",
    img: degreasingImg,
    description:
      "Degreasing Chemicals effectively remove oils, grease, and contaminants from surfaces to prepare components for plating or coating processes.",
  },
],
  },
  {
    id: 2,
    slug: "basic-and-lab-chemicals",
    name: "Basic-Lab-Chemicals",
  bannerTitle: "Basic Lab Chemicals",
  bannerImage: BasicLabChemicalsBannerImg, 
    industries: [
      { id: 1, name: "Automotive", icon: FaCar },
      { id: 2, name: "General", icon: FaCogs },
      { id: 3, name: "Defense", icon: FaShieldAlt },
      { id: 4, name: "Electronics", icon: FaTv },
      { id: 5, name: "PCB", icon: FaMicrochip },
    ],
    substrates: [
      { id: 1, name: "Mild Steel", img: msImg },
      { id: 2, name: "Brass", img: brassLabImg },
      { id: 3, name: "Stainless Steel", img: stainlessLabImg },
      { id: 4, name: "ABS", img: absLabImg },
      { id: 5, name: "Copper", img: copperLabImg },
      { id: 6, name: "Aluminum", img: aluminumLabImg },
    ],
products : [
  {
    id: 1,
    name: "CHROMIC ACID FLAKES & LIQUID",
    img: chromicAcidImg,
    description:
      "Chromic Acid Flakes are a powerful oxidizing agent used in metal finishing and electroplating. They are essential in the preparation of surfaces for plating, ensuring a smooth and durable coating.",
  },
  {
    id: 2,
    name: "NICKEL SULPHATE",
    img: nickelSulphateImg,
    description:
      "Nickel sulphate, or nickel(II) sulfate, is an inorganic compound (NiSO₄) that appears as blue-green crystals and is highly soluble in water. It is primarily used in electroplating for surface treatment, but also as a catalyst, in battery materials, and for producing other nickel salts.",
  },
  {
    id: 3,
    name: "NICKEL SUPHAMATE",
    img: nickelSuphamateImg,
    description:
      "Nickel sulfamate is a chemical compound and raw material used primarily for electroplating and electroforming, offering high deposition rates, low internal stress, and good ductility for durable, high-purity nickel deposits. Its applications span across the aerospace, automotive, and military sectors, providing wear, corrosion, and thermal resistance for components such as rocket thrust chambers, industrial rollers, and firearm parts.",
  },
  {
    id: 4,
    name: "NICKEL CHLORIDE",
    img: nickelChlorideImg,
    description:
      "Nickel chloride (NiCl₄) is a chemical compound, a salt, that is a key source of nickel for chemical synthesis and has applications in electroplating, batteries, and catalysis",
  },
  {
    id: 5,
    name: "BORIC ACID",
    img: boricAcidImg,
    description:
      "Boric acid is a crucial buffer in nickel and acid zinc plating baths>>, primarily to stabilize pH by neutralizing hydroxide ions generated at the cathode, which prevents nickel hydroxide precipitation. This buffering action improves deposit quality, enhancing brightness, smoothness, and ductility, while also reducing pitting and internal stress. It also extends the bath life by preventing anode passivation and reducing the need for frequent pH adjustments.",
  },
  {
    id: 6,
    name: "CAUSTIC SODA FLAKES",
    img: causticSodaImg,
    description:
      "Caustic soda flakes, or sodium hydroxide (NaOH), are used in plating processes for degreasing and etching metals because of their strong alkaline properties, which break down organic materials like oils and grease, and their high solubility in water. They create a highly alkaline solution that helps prepare a metal surface for the subsequent electroplating step. ",
  },
  {
    id: 7,
    name: "NICKEL CARBONATE",
    img: nickelCarbonateImg,
    description:
      "Nickel carbonate is a light green, water-insoluble, crystalline solid primarily used in electroplating, as a catalyst for chemical reactions like hydrogenation, and as a precursor for other nickel compounds.",
  },
  {
    id: 8,
    name: "OTHER BASIC LAB CHEMICALS",
    img: labChemicalsImg,
    description:
      "A range of essential laboratory chemicals that support surface treatment, plating, and industrial applications.",
  },
],
  },
  {
    id: 3,
    slug: "metals",
    name: "METALS",
  bannerTitle: "METALS",
  bannerImage: METALSBannerImg, 
    industries: [
      { id: 1, name: "Automotive", icon: FaCar },
      { id: 2, name: "General", icon: FaCogs },
      { id: 3, name: "Defense", icon: FaShieldAlt },
      { id: 4, name: "Electronics", icon: FaTv },
      { id: 5, name: "PCB", icon: FaMicrochip },
    ],
    // substrates: [
    //   { id: 1, name: "Mild Steel", img: msImg1 },
    //   { id: 2, name: "Brass", img: brassImg1 },
    //   { id: 3, name: "Stainless Steel", img: stainlessImg1 },
    //   { id: 4, name: "ABS", img: absImg1 },
    //   { id: 5, name: "Copper", img: copperImg1 },
    //   { id: 6, name: "Aluminum", img: aluminumImg1 },
    // ],
    products: [
      {
        id: 1,
        name: "NICKEL OF ALL DIMENSIONS",
        img: nickelImg1,
        description:
          "Nickel anodes are used in nickel plating baths. They can be shaped in various dimensions. It is high purity nickel for decorative and technical electrolytic coatings.",
      },
      {
        id: 2,
        name: "ZINC",
        img: zincImg1,
        description:
          "zinc anodes plates and slabs are made from high-purity SHG (Super High Grade) zinc. The very low impurity content guarantees a high-quality zinc plating.",
      },
      {
        id: 3,
        name: "OXYGEN FREE COPPER",
        img: oxygenCopperImg1,
        description:
          "Oxygen-free copper (OFC) anodes are used in electroplating, particularly in non-acidic and alkaline copper baths, because their high purity and low oxygen content minimize anode polarization and prevent contamination of the plating solution.",
      },
      {
        id: 4,
        name: "PHOSPHORISED PURE COPPER",
        img: phosphorCopperImg1,
        description:
          "Phosphorized copper is a high-purity copper alloyed with a small, controlled amount of phosphorus, specifically used as anodes for high-quality electroplating. The phosphorus is crucial for creating a stable, adherent black film on the anode's surface during acid copper plating, which prevents impurities and fine copper particles from contaminating the plating bath.",
      },
      {
        id: 5,
        name: "TIN",
        img: tinImg1,
        description:
          "A tin anode is a high-purity tin bar, sheet, or custom shape used in electroplating to dissolve tin into the electrolyte solution and deposit it onto a workpiece. These anodes are crucial for various industries, including food processing, automotive, and electronics, as they provide corrosion resistance, improved solderability, a bright finish, and act as a cost-effective, non-toxic plating solution. They are available in pure tin or alloyed with other metals like lead, and their effectiveness depends on high purity and proper design. ",
      },
      {
        id: 6,
        name: "LEAD",
        img: leadImg1,
        description:
          "Lead-tin anode can be used in electroplating and corrosion protection. Lead-tin anode has high corrosion resistance and the ability to plate a variety of metals. It's mainly used for plating copper, nickel, chromium, zinc, tin, lead, cadmium, silver, gold, and other metals.",
      },
    ],
  },
{
  id: "4",
  slug: "abrasives",
  name: "Abrasives",
  bannerTitle: "Abrasives",
  bannerImage: abrasivesBannerImg, 

industries: [
  { id: "auto", name: "Automotive & Auto Ancillary", icon: FaCar },
  { id: "steel", name: "Steel & Foundry", icon: FaCogs },
  { id: "aero", name: "Aerospace", icon: FaSpaceShuttle },
  { id: "metal", name: "Metal Fabrication & General Engineering", icon: FaCogs }, 
  { id: "furniture", name: "Furniture & Decorative", icon: FaChair },               
  { id: "electronics", name: "Electronics & Home Appliances", icon: FaTv },
  { id: "construction", name: "Building & Constructions", icon: FaBuilding }
],


    substrates: [
    { id: 1, name: "Stainless Steel", img: stainlessLabImg },
    { id: 2, name: "Plywood", img: PlywoodImg },
    { id: 3, name: "Aluminum", img: aluminumLabImg },
    { id: 4, name: "MDF & Veneers", img: mdfImg },
    { id: 5, name: "Mild Steel", img: msImg },
    { id: 6, name: "ABS", img: absLabImg },
  ],

  products: [
    {
      id: "bonded-abrasives",
      name: "BONDED ABRASIVES",
      img: bondedImg, // replace with actual image
      description: [
        "Bonded Abrasives include a wide range of precision grinding and cutting solutions such as:",
        "Cylindrical Wheels",
        "Centerless Wheels",
        "Toolroom Wheels",
        "ID Grinding Wheels",
        "Regulating Wheels",
      ],
      pdf: bondedpdf,
    },
    {
      id: "coated-abrasives",
      name: "COATED ABRASIVES",
      img: coatedImg,
      description: [
        "Coated Abrasives are designed for finishing, polishing, and surface preparation including:",
        "Fiber Disc & Flap Disc",
        "Narrow & Wide Belts",
        "Cloth & Paper Rolls",
        "Emery & Waterproof Sheets",
        "Velcro & PSA Disc",
        "Flap Wheels & Mops"
      ],
      pdf: coatedpdf,
    },
    {
      id: "non-woven-abrasives",
      name: "NON-WOVEN ABRASIVES",
      img: nonwovenImg,
      description: [
        "Non-Woven Abrasives are versatile for polishing, finishing, and cleaning surfaces, such as:",
        "Hand Pads",
        "Convolute Wheels",
        "Polishing Matt Wheels",
        "SCF Disc & Belts",
        "Nex Wheels",
      ],
      pdf: nonwovenpdf,
    },
    {
      id: "super-abrasives",
      name: "SUPERABRASIVES",
      img: superabrasiveImg,
      description: [
        "Super Abrasives deliver precision performance with:",
        "Dressers",
        "Diamond Wheels",
        "CBN Wheels",
    ],
    pdf: superabrasivepdf,
    },
    {
      id: "thin-wheels",
      name: "THIN WHEELS",
      img: thinwheelsImg,
      description: [
        "Thin Wheels are designed for cutting, grinding, and precision applications including:",
        "DCD-AG 4”, AG5”, AG7”, & AG9",
        "Cut-Off Wheels – AG4”, AG5”, AG7” & AG9",
        "Cutting Wheels – 14",
      ],
      pdf: thinwheelspdf,
    },
    {
      id: "construction-products",
      name: "CONSTRUCTION PRODUCTS",
      img: constructionImg,
      description: [
        "Construction Abrasive Solutions include:",
        "Wood Cutters",
        "Diamond Blades"
      ],
      pdf: constructionpdf,
    }
  ]
},
{
  id: 5,
  slug: "cutting-tools",
  name: "CUTTING TOOLS",
  bannerTitle: "CUTTING TOOLS",
  bannerImage: CUTTINGTOOLSBannerImg,
industries: [
  { id: 1, name: "Automotive & Auto Ancillary", icon: FaCar },
  { id: 2, name: "Steel & Foundry", icon: FaCogs },           // replaced FaIndustry
  { id: 3, name: "Aerospace", icon: FaSpaceShuttle },        // replaced FaRocket
  { id: 4, name: "Metal Fabrication & General Engineering", icon: FaCogs },
  { id: 5, name: "Furniture & Decorative", icon: FaChair },
  { id: 6, name: "Electronics & Home Appliances", icon: FaTv },
  { id: 7, name: "Building & Constructions", icon: FaBuilding },
],
substrates: [
      { id: 1, name: "Titanium", img: TitaniumImg },
      { id: 2, name: "Inconel", img: InconelImg },
      { id: 3, name: "Nickel", img: NickelImg },
      { id: 4, name: "Stainless Steel", img: stainlessLabImg },
      { id: 5, name: "Cast Iron", img: CastIronImg },
      { id: 6, name: "Aluminum", img: aluminumLabImg },
    ],
  products: [
    {
      id: 1,
      name: "Milling Cutters & Solid End Mills",
      img: millingImg1,
      description:
        "High-performance milling cutters and solid end mills designed for precision machining with excellent durability and surface finish.",
    },
    {
      id: 2,
      name: "ISO Turning Inserts, Grooving & CBN Inserts",
      img: turningInsertsImg1,
      description:
        "ISO-standard turning inserts, grooving tools, and CBN inserts for efficient material removal and superior tool life.",
    },
    {
      id: 3,
      name: "Carbide Drills, Boring Heads & Reamers",
      img: carbideDrillsImg1,
      description:
        "Precision carbide drills, boring heads, and reamers engineered for high accuracy and excellent performance in drilling operations.",
    },
    {
      id: 4,
      name: "Turning, Milling & Tapping",
      img: turningMillingTappingImg1,
      description:
        "Comprehensive solutions for turning, milling, and tapping applications to achieve high productivity and consistent machining quality.",
    },
    {
      id: 5,
      name: "Rotating Holders, Stationary Adapters & Shrink Fit Devices",
      img: toolingSystemsImg1,
      description:
        "Advanced tooling systems including rotating holders, stationary adapters, and shrink-fit devices for maximum stability and precision.",
    },
  ],
},
{
  id: 6,
  slug: "wood-glass-coatings",
  name: "WOOD & GLASS COATINGS",
  bannerTitle: "WOOD & GLASS COATINGS",
  bannerImage: WOODGLASSCOATINGSBannerImg,
  industries: [
    { id: 1, name: "Furniture", icon: FaChair },
    { id: 2, name: "Builders", icon: FaBuilding },
    { id: 3, name: "Interior Designers", icon: FaPaintRoller },
    { id: 4, name: "Architects", icon: FaBuilding },
    { id: 5, name: "General", icon: FaCogs },
  ],
  substrates: [
    { id: 1, name: "MDF", img: mdfImg },
    { id: 2, name: "Wood", img: woodImg },
    { id: 3, name: "Glass", img: glassImg },
    { id: 4, name: "HDF", img: hdfImg },
    { id: 5, name: "Tiles", img: tilesImg },
  ],
  products: [
    { id: 1, name: "ALKYD POLYURETHANE COATINGS", img: alkydPolyurethaneImg, description: "Alkyd polyurethanes are most versatile range of coatings suitable for almost all type of interior surfaces where yellowing is not permitted. They offer high covering & wide possibilities along with competitive pricing." },
    { id: 2, name: "ACRYLIC POLYURETHANE COATINGS", img: acrylicPolyurethaneImg, description: "Acrylic Polyurethane coatings are 100% anti-yellowing coatings with high clarity, excellent chemical resistance and excellent finish." },
    { id: 3, name: "UV COATINGS", img: uvCoatingsImg, description: "UV-curable coatings are liquid chemical compositions that do not contain any solvent or water. Upon application, the coating is immediately exposed to UV energy without the need to dry or evaporate prior to cure. The applied coating composition reacts to form a solid surface layer via the reactive process described and appropriately termed photopolymerization. Since there is no evaporation needed before curing, the application and cure process are remarkably efficient and cost effective." },
    { id: 4, name: "WATER BORNE EXTERIOR & INTERIOR COATINGS", img: waterBorneImg, description: "Water Borne Coatings possess very low content of volatile matter and hence offer Eco - friendly option for Solvent borne coatings. Additionally, they are most preferred products for all exterior applications due to their excellent outdoor performance and durability." },
    { id: 5, name: "PU GLASS COATINGS", img: puGlassImg, description: "We offer highly specialized Coatings for application on glass which can be applied directly without any need of adhesion promoter, these products are specially designed for Glass and offer excellent adhesion along with excellent opacity and covering." },
    { id: 6, name: "EPOXY & ACRYLIC ISOLATORS", img: epoxyAcrylicImg, description: "Epoxy Isolator is an acrylic undercoat for all wood types, used as a universal undercoat and a penetrative coat, that protects topcoat." },
    { id: 7, name: "MELAMINE", img: melamineImg, description: "Melamine Coatings are the most commonly used products for wood coatings that are suitable for almost all type of interior surfaces expect where yellowing is not permitted. They have wide possibilities of application processes and offer high covering, rapid drying and curing properties along with competitive pricing." },
    { id: 8, name: "SPECIAL EFFECTS – METALLIC, CRACKLE, PATINA, PEARL & TEXTURE", img: specialEffectsImg, description: "Special effect products are designed to give highly decorative and aesthetic finish to the wood, metallic, crackle, patina, pearl & texture effects." },
    { id: 9, name: "GLAZERS & DYES", img: glazersDyesImg, description: "Glazers are special stains that add richness, intense depth and colour to the wood. Glazer is the type of wood finish which combines richness and depth to create a special warm glow only in the grains of wood." },
    { id: 10, name: "SOLVENT, WATER BASE & UNIVERSAL STAINS", img: stainsImg, description: "Stains are used to give the wood a different colour but with transparency which reveals structure of wood. The type of pigment used is important in order to achieve the right colour and light resistance of stain." },
    { id: 11, name: "FIRE RETARDANT COATINGS", img: fireRetardantImg, description: "Fire Retardant Coatings provide safety by slowing down the spread of flames on coated surfaces." },
    { id: 12, name: "PIGMENTED COATINGS", img: pigmentedImg, description: "Topcoat Finishes are also available for all colours in colour chart consisting of 1000 ready colours, RAL & NCS colour charts. Furthermore, we can develop any colour in any finish as per the customer needs and requirements." },
  ],
},
{
  id: 7,
  slug: "metal-coatings",
  name: "METAL COATINGS",
  bannerTitle: "METAL COATINGS",
  bannerImage: metalCoatingsBannerImg, 
  industries: [
    { id: 1, name: "Auto Components", icon: FaCar },
    { id: 2, name: "Consumer Goods", icon: FaBoxOpen },
    { id: 3, name: "Imitation Jewelry", icon: FaGem },
    { id: 4, name: "General Industry", icon: FaCogs },
    { id: 5, name: "Specialties", icon: FaStar },
    { id: 6, name: "Handicraft", icon: FaHandsHelping },
    { id: 7, name: "Home Furnishing", icon: FaCouch },
    { id: 8, name: "Cookware", icon: FaUtensils },
    { id: 9, name: "Energy & Infrastructure", icon: FaBolt }
  ],
  substrates: [
    { id: 1, name: "Mild Steel", img: mildSteelImg3 },
    { id: 2, name: "Brass", img: brassImg3 },
    { id: 3, name: "Stainless Steel", img: stainlessSteelImg3 },
    { id: 4, name: "ABS", img: absImg3 },
    { id: 5, name: "Aluminum", img: aluminumImg3 },
    { id: 6, name: "FRP", img: frpImg3 },
    { id: 7, name: "Plastic & Steel", img: plasticSteelImg3 }
  ],
  products: [
    { id: 1, name: "EPOXY COATINGS", img: epoxyImg, description: "Epoxy paint is a popular choice for coating metal surfaces due to its durability and protective properties. Epoxy paint is made from a combination of epoxy resin and curing agent, which creates a strong bond to the surface it’s applied to. When used on metal, epoxy paint provides a layer of protection against elements like moisture, corrosion, and general wear and tear. This makes it an effective solution for both indoor and outdoor metal applications, ranging from automotive components to household items and machinery." },
    { id: 2, name: "POLYURETHANE COATINGS", img: polyurethaneImg, description: "Polyurethane coatings offer many advantages for metal substrate applications. Polyurethanes have excellent appearance, mechanical performance, UV resistance, and chemical resistance compared with other coatings." },
    { id: 3, name: "ANTI BACTERIAL COATINGS", img: antibacterialImg, description: "Anti Bacterial Coatings prevent bacterial growth, ideal for hygiene-sensitive applications." },
    { id: 4, name: "SOFT FEEL LACQUER", img: softFeelImg, description: "Our soft feel coating paint offers a luxurious, velvety texture that not only looks premium but also feels exceptional to the touch. Widely used in automotive interiors, electronic devices, cosmetic packaging and more, soft feel coatings provide a matte finish that is both durable and elegant." },
    { id: 5, name: "MONO COAT DTM", img: monoCoatImg, description: "A Monocoat DTM (Direct-to-Metal) is a specialized, single-layer coating designed to provide both corrosion protection and a finished look on metal surfaces, eliminating the need for a separate primer. It typically offers excellent corrosion and impact resistance, can be applied over previously treated or even rusted surfaces, and comes in one-component (1K) or two-component (2K) formulations to meet different durability and application needs." },
    { id: 6, name: "ELECTRO PHORETIC", img: electrophoreticImg, description: "Electrophoretic for metal refers to electrophoretic painting (E-coating) or electrophoretic deposition (EPD), a process where an electric field is used to apply a uniform, durable coating of water-based paint or resin to a metal surface. This process provides excellent corrosion resistance, uniform coverage even on complex shapes, and can offer decorative finishes in various colors and gloss levels for applications like automotive parts, home appliances, and building hardware." },
    { id: 7, name: "THERMOPLASTIC ACRYLIC - TPA", img: tpaImg, description: "SBL's Thermoplastic Acrylic Paint offers a versatile, one-coat solution for various substrates like metal, plastic, wood." },
    { id: 8, name: "THERMOSETTING ACRYLIC - TSA", img: tsaImg, description: "Thermosetting acrylic (TSA) is a heat-cured paint system for metal, offering excellent adhesion, UV resistance, durability, and corrosion resistance, often used for automotive, fan, and industrial components. These paints use thermosetting acrylic resins that cure when heated, typically with melamine formaldehyde or proprietary hardeners, to form a hard, long-lasting film." },
    { id: 9, name: "UV CURABLE", img: uvCurableImg, description: "UV curing for metal provides fast, durable, and high-quality coatings, protecting against corrosion and abrasion, with increased efficiency and sustainability." }
  ]
}

];
